import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Image extends PureComponent {
  static propTypes = {
    alt: PropTypes.string.isRequired,
    className: PropTypes.any,
    src: PropTypes.string.isRequired,
    // This is if you have different resolution images for retina or HD.
    // You can provide the image and image width for each resolution type
    // and the browser will decide which image to use based on the screen.
    srcSet: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string,
        resolution: PropTypes.string, // Actual image width
      })
    ),
  };

  _constructImageSrcSet = () => {
    if (this.props.srcSet) {
      const srcSet = this.props.srcSet.map((set) => {
        return `${set.src} ${set.resolution}`;
      });

      return srcSet.join(",");
    }

    return null;
  };

  render() {
    const classes = classNames("image", this.props.className);

    const { className, srcSet, alt, ...rest } = this.props;

    return (
      <img
        className={classes}
        srcSet={this._constructImageSrcSet()}
        alt={this.props.alt}
        {...rest}
      />
    );
  }
}
